import { statisticsConstants } from '../constants/statistics';

const initialState = {
  config: [],
  tabs: [],
  dict: {},
  charts: [],
  totalCharts: {},
  filters: {},
  presets: [],
  currentTab: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case statisticsConstants.SET_STATS_TABS_SUCCESS:
      return {
        ...state,
        tabs: action.tabs,
      };

    case statisticsConstants.SET_STATS_CHARTS_SUCCESS:
      return {
        ...state,
        charts: action.charts,
        totalCharts: action.totalCharts,
      };

    case statisticsConstants.SET_STATS_REQUEST:
      return {
        ...state,
        config: [],
      };
    case statisticsConstants.SET_STATS_SUCCESS:
      const { tabs: config } = action.data;
      return {
        ...state,
        config,
      };
    case statisticsConstants.SET_STATS_DICTIONARY_SUCCESS:
      const type = Object.keys(action.dictionary)[0];
      let dictionary;

      if(type && state.dict[type]) {
        dictionary = {[type]: [...state.dict[type]]};
        action.dictionary[type].forEach(el => {
          const stateItem = dictionary[type].find(item => item.id === el.id);
          if(!stateItem) {
            dictionary[type].push(el);
          }
        });
      } else {
        dictionary = {...action.dictionary};
      }
      return {
        ...state,
        dict: type ? {...state.dict, ...dictionary} : state.dict,
      };
    case statisticsConstants.SET_STATS_FILTERS_SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    case statisticsConstants.CREATE_WEBMASTER_PRESET_SUCCESS:
      return {
        ...state,
        presets: [action.preset, ...state.presets],
      };
    case statisticsConstants.REMOVE_WEBMASTER_PRESET_SUCCESS:
      return {
        ...state,
        presets: state.presets.filter(({ id }) => id !== action.id),
      };
    case statisticsConstants.SET_WEBMASTER_PRESETS_SUCCESS:
      return {
        ...state,
        presets: action.presets,
      };
    case statisticsConstants.UPDATE_WEBMASTER_PRESET_SUCCESS:
      return {
        ...state,
        presets: state.presets.map(filter => {
          if (filter.id === action.id) {
            return {
              id: filter.id,
              ...action.filter,
            };
          }

          return filter;
        }),
      };
    case statisticsConstants.RESET_STATS_FILTERS:
      return {
        ...state,
        filters: {},
      };

    case statisticsConstants.SET_CURRENT_TAB: 
      return {
        ...state,
        currentTab: action.tab,
      };
    default:
      return state;
  }
};
